import React from "react";
import { FieldContext, IFieldContext } from "../../../constants";
import Field from "./Field";
import { IFieldProps } from "./types";

type TOuterProps<TProps extends IFieldContext> = Omit<TProps, keyof IFieldContext> &
    Partial<IFieldContext> &
    Partial<IFieldProps>;

export default function withField<TProps extends IFieldContext>(WrappedComponent: React.ComponentType<TProps>) {
    return React.forwardRef<HTMLElement, TOuterProps<TProps>>(
        ({ label, helperText, name, labelTrailing, error, tooltip, ...props }, ref) => {
            const wrappedJsx = (
                <FieldContext.Consumer>
                    {context => <WrappedComponent ref={ref} {...context} error={error} {...(props as TProps)} />}
                </FieldContext.Consumer>
            );

            if (
                label ||
                (helperText && typeof helperText !== "boolean") ||
                (error && typeof error !== "boolean") ||
                tooltip
            ) {
                return (
                    <Field
                        label={label}
                        helperText={helperText}
                        name={name}
                        error={error}
                        labelTrailing={labelTrailing}
                        tooltip={tooltip}
                    >
                        {wrappedJsx}
                    </Field>
                );
            }

            return wrappedJsx;
        }
    );
}
